var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('base-row',{attrs:{"dense":""}},_vm._l((_vm.products),function(product){return _c('base-col',{key:product.id,attrs:{"cols":"6","sm":"6","md":"3"}},[_c('v-lazy',{staticClass:"fill-height",attrs:{"options":{
          threshold: 0.5,
        },"transition":"fade-transition"}},[_c('card-menu',{attrs:{"product":product}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }